import React, {useState, useEffect, useContext} from "react";
import AdminListPage from '../administration/components/AdminListPage';
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";

export default function AdministrationUsers(){
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"calc(100vh - 160px)",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px",
		overflow:'hidden'
	};
	
	return (
		<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
			<AdminListPage
					title="Users"
					headerTitle="User Name"
					headerDescription="Description"
					restUrl="users"
					adminPage="administrationusersedit"
					downloadUrl="spreadsheetexportuser"
					uploadUrl="spreadsheetimportuser"
				/>
		</div>
		
	);
}